module.exports = __webpack_public_path__ + "img/sii--avatar.a164f199.svg";